// @ts-nocheck
/*import {
  SET_GAME,
  SET_GAMES_WITH_FILTERS,
  SET_GAMES_BY_TEAM,
  SET_ALL_GAMES,
  SET_GAMES_BY_DIVISION
} from '../constants/actions';*/
import ActionTypes from '../constants/actions';
import Immutable from 'immutable';
import _ from 'lodash';

const defaultState = new Immutable.Map({});

export default (state = defaultState, action) => {
  switch (action.type) {
    case ActionTypes.SET_GAMES_BY_DIVISION:
      _.map(action.games, (game) => {
        state = state.set(game._id, game);
      });
      return state;
      break;
    case ActionTypes.SET_GAMES_BY_TEAM:
      _.map(action.games, (game) => {
        state = state.set(game._id, game);
      });
      return state;
      break;
    case ActionTypes.SET_GAMES_WITH_FILTERS:
      _.map(action.games, (game) => {
        state = state.set(game._id, game);
      });
      return state;
      break;
    case ActionTypes.UPDATE_GAME:
    case ActionTypes.ADD_GAME:
    case ActionTypes.SET_GAME:
      return state.set(action.game._id, action.game);
      break;
    case ActionTypes.DELETE_GAME:
      return state.remove(action.game._id);
      break;
    default:
      return state;
  }
};
